module.exports = __webpack_public_path__ + "img/towers.15da0541.png";